import { render, staticRenderFns } from "./DetailsProject.vue?vue&type=template&id=31337427&scoped=true&"
import script from "./DetailsProject.vue?vue&type=script&lang=js&"
export * from "./DetailsProject.vue?vue&type=script&lang=js&"
import style0 from "./DetailsProject.vue?vue&type=style&index=0&id=31337427&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31337427",
  null
  
)

export default component.exports